import { FC, useState } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useReactFlow } from "@xyflow/react";
import __ from "src/utils/Translations";
import useOrgchartEmployeesStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/store";

interface LoadMoreHandleProps {
  supervisorId: string;
  nextCursor: string;
  onLoadMore: (supervisorId: string, cursor: string) => Promise<string[]>;
}

const LoadMoreHandle: FC<LoadMoreHandleProps> = ({
  supervisorId,
  nextCursor,
  onLoadMore,
}) => {
  const [loading, setLoading] = useState(false);
  const { setCenter, getNode } = useReactFlow();

  const handleClick = async () => {
    setLoading(true);
    useOrgchartEmployeesStore.getState().setSearchedNodeId(null);
    const newNodeIds = await onLoadMore(supervisorId, nextCursor);

    // Wait for layout to complete, then center on middle node
    setTimeout(() => {
      if (newNodeIds.length > 0) {
        const middleIndex = Math.floor(newNodeIds.length / 2);
        const targetNode = getNode(newNodeIds[middleIndex]);

        if (targetNode?.position) {
          setCenter(targetNode.position.x + 170, targetNode.position.y, {
            zoom: 0.6,
            duration: 800,
          });
        }
      }
      setLoading(false);
    }, 400);
  };

  return (
    <Button
      onClick={handleClick}
      variant="outlined"
      sx={{
        minWidth: "150px",
        position: "absolute",
        bottom: "50%",
        right: "-50%",
        transform: "translateY(50%)",
        padding: "0.375rem 1rem",
        backgroundColor: "white",
        border: "1px solid #BDBDBD",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      {loading ? (
        <CircularProgress size={16} color="primary" />
      ) : (
        <Typography
          color="textPrimary"
          variant="body2"
          sx={{ fontWeight: "700" }}
        >
          {__("Pokaż więcej")} +
        </Typography>
      )}
    </Button>
  );
};

export default LoadMoreHandle;
